import styled from "styled-components";
import { OriginType } from "../../../models/track-type.enum";
import { TABLET } from "../../../styles/breakpoints";

interface ContainerProps {
  originType?: OriginType;
  isSelecteds?: boolean;
  isControl?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
  width: 100%;
  padding: 0 1rem;
  color: #fff;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    min-height: 200px;
    background: linear-gradient(
      257.28deg,
      rgb(2, 72, 114) 7.91%,
      rgb(0, 33, 52) 106.14%
    );
    z-index: -1;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  width: 100%;
  max-width: 1440px;
  margin: 1.5rem auto;
  justify-content: space-between;
  padding: 0 1rem;
  img {
    width: 250px;
    background-color: #fff;
    padding: 0.5rem;
    border-radius: 0.5rem;
    margin-left: 1rem;
  }

  @media (min-width: ${TABLET}) {
    padding-left: 2rem;
  }
`;

export const Notications = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Plan = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 1rem;
  svg {
    margin: 0 0.5rem;
    vertical-align: middle;
    &:hover {
      cursor: pointer;
    }
  }
`;

export const Tooltip = styled.div`
  z-index: 5 !important;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;